<template>
    <div class="row">
        <!-- BEGIN Fax country code -->
        <section class="col col-3">
            <label class="label">{{ $label('common.fax_number') }}</label>

            <label class="input">
                <!-- <input v-model="operator.entity_details.fax.country_code" -->
                <input v-model="faxNumber.prefix"
                    v-on:keyup.enter="requestModelChange"
                    :class="{ 'text-input-error': hasError('prefix') }"
                    :disabled="updating"
                    type="text"
                    placeholder="+XX"
                />
            </label>

            <p v-if="hasError('prefix')" class="text-danger">{{ getError('prefix') }}</p>
        </section>
        <!-- END Fax country code -->

        <!-- BEGIN Fax number -->
        <section class="col col-9">
            <label class="label">&nbsp;</label>

            <label class="input">
                <i class="icon-append icon-print"></i>
                <!-- <input v-model="operator.entity_details.fax.number" -->
                <input v-model="faxNumber.number"
                    v-on:keyup.enter="requestModelChange"
                    :class="{ 'text-input-error': hasError('number') }"
                    :disabled="updating"
                    type="text"
                    placeholder="XXXXXXXX"
                />
            </label>

            <p v-if="hasError('number')" class="text-danger">{{ getError('number') }}</p>
        </section>
        <!-- END Fax number -->
    </div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors.js';
import ModelActionsMixin from '@/mixins/ModelActions.js';

export default {
    props: ['resourceType', 'resourceId', 'componentParentView', 'updating'],

    mixins: [FormErrorsMixin, ModelActionsMixin],

    data() {
        return {
            validatedInputs: ['prefix', 'number'],
            parentView: this.componentParentView,
            modelData: 'faxNumber',
            faxNumber: {
                id: null,
                prefix: null,
                number: null,
            },
        }
    },

    mounted() {
        if (this.resourceId != null) {
            this.initializeFaxNumber();
        }
    },

    methods: {
        initializeFaxNumber() {
            this.getFaxNumber();
        },

        getFaxNumber() {
            let endpoint = this.$partnerEndpoint(this.resourceType + '/' + this.resourceId + '/fax-number');
            Api().get(endpoint)
                .then((response) => {
                    this.faxNumber = response.data.data;
                    this.emitModelLoadedEvent();
                })
                .catch((error) => {
                    this.resetModel();
                    this.emitModelLoadedEvent(false);
                });
        },

        storeModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint(this.resourceType + '/' + this.resourceId + '/fax-number');

            Api().post(endpoint, this.faxNumber)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },

        updateModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('fax-numbers/' + this.faxNumber.id);

            Api().put(endpoint, this.faxNumber)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },

        deleteModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('phone-numbers' + this.phoneNumber.id);

            Api().delete(endpoint)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                });
        },
    },

    watch: {
        resourceId(resourceId) {
            if (resourceId) {
                this.initializeFaxNumber();
            }
        },
    }
}
</script>
